import React from 'react'
import { connect } from 'react-redux'

import $ from 'jquery';
import { alterouPagina } from '../../util/filtros';
import buscarMapasVeiculos from '../../actions/mapa-veiculo/buscarMapasVeiculos';
import MapaVeiculo from './MapaVeiculo';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoMapasVeiculos from './PaginacaoMapasVeiculos';
import BotoesPaginacaoMapasVeiculos from './BotoesPaginacaoMapasVeiculos';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';

import determinarPaginaAtualMapasVeiculos from '../../actions/mapa-veiculo/determinarPaginaAtualMapasVeiculos';
import alterarRegistrosPorPaginaMapasVeiculos from '../../actions/mapa-veiculo/alterarRegistrosPorPaginaMapasVeiculos';
import adicionarFiltroMapaVeiculo from '../../actions/mapa-veiculo/adicionarFiltroMapaVeiculo';
import { campoTipoVeiculo } from '../../util/constantsUtil';
import Select from 'react-select';
import { Field, change as changeFieldValue, reduxForm } from 'redux-form';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-tabela-dados">
    <div className="row cabecalho-desktop">
      <div className="col-lg-5 col-xl-5">Nome</div>
      <div className="col-lg-5 col-xl-5">Estado</div>
      <div className="col-lg-2 col-xl-2">Ações</div>
    </div>
  </div>
);

export class MapasVeiculos extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      parametros: {
        modelo: props.filtrosMapaVeiculo.modelo,
        tipoVeiculo: props.filtrosMapaVeiculo.tipoVeiculo || []
      }
    };
  }

  componentDidMount () {
    $('input[name=modeloVeiculo]').val(this.props.filtrosMapaVeiculo.modelo);
    this.props.buscarMapasVeiculos(this.props.filtrosMapaVeiculo, this.props.paginaAtual, this.props.registrosPorPagina);
  }

  componentDidUpdate (prevProps) {
    if (alterouPagina(this.props, prevProps) || this.props.filtrosMapaVeiculo !== prevProps.filtrosMapaVeiculo) {      
      this.props.buscarMapasVeiculos(this.props.filtrosMapaVeiculo, this.props.paginaAtual, this.props.registrosPorPagina);
    }
  }

  buscar () {
    this.zerarPaginacao();    
    this.props.adicionarFiltroMapaVeiculo(this.state.parametros);
  }

  exibirMapas () {
    if (this.props.mapasVeiculos) {
      return (<CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoMapasVeiculos}
                                     BotoesPaginacao={BotoesPaginacaoMapasVeiculos}>
        {this.props.mapasVeiculos.map(mapa => <MapaVeiculo key={mapa.id} mapaVeiculo={mapa}
                                                           selecionar={this.props.selecionar}
                                                           selecionado={this.props.selecionado}/>)}
      </CabecalhoRodapeTabela>)
    }
  }

  handleChange (event) {    
    this.setState({ parametros: { modelo: event.target.value } })
  }

  zerarPaginacao () {
    this.props.determinarPaginaAtualMapasVeiculos(1)
    this.props.alterarRegistrosPorPaginaMapasVeiculos(10)
  }

  limparBusca () {
    this.setState({ parametros: '', buscado: false });
    $('input[name=modeloVeiculo]').val('');    
    this.props.changeFieldValue('formularioMapasVeiculos',
      'tipo', null);
    this.props.buscarMapasVeiculos({}, this.props.paginaAtual, this.props.registrosPorPagina);
    this.props.adicionarFiltroMapaVeiculo('');
  }

  exibirCampoBusca () {
    return (<React.Fragment>
      <div className="input-group mb-3 mt-3" style={{ alignItems: 'center'}}>
        <div className="col-12 col-sm-12 col-md-6 mb-2 mt-4">
          <div className="form-group" >
            <input name='modeloVeiculo' className="form-control form-control-md campo-busca" type="text" style={{ height: 38 }}
                   placeholder="Modelo do Veículo" onChange={this.handleChange.bind(this)} disabled={this.props.filtrosMapaVeiculo}/>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-3 mb-2">
          <div className="form-group">
          <label>Tipo Veículo</label>
            <Field  name='tipo' 
                    component={this.exibirComboTipoVeiculo.bind(this)}/>
          </div>
        </div>

        {this.props.filtrosMapaVeiculo ? <div className="col-12 col-sm-9 col-md-2">
          <button onClick={() => this.limparBusca()}
                  className='btn botaoLogar btn-vermelho'>Limpar
          </button>
        </div> : <div className="col-12 col-sm-9 col-md-2">
            <button onClick={() => this.buscar()}
                    className='btn botaoLogar btn-laranja'>Buscar
            </button>
          </div>
          }
      </div>
    </React.Fragment>)
  }

  exibirComboTipoVeiculo(event) {
    return (
        <div>
            <Select
                {...event.input}
                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                placeholder='Selecione um tipo...'
                options={campoTipoVeiculo.map(elemento => ({
                    label: elemento.valor,
                    value: elemento.chave
                }))}
                onChange={value => {event.input.onChange(value)
                  const parametros = {
                    modelo: this.state.parametros.modelo,
                    tipoVeiculo: [value.value]
                  };
                  this.setState({ parametros: parametros })}}
                onBlur={() => event.input.onBlur()}                
            />
            {event.meta.touched
            && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
        </div>
    )
  }

  exibirBotaoNovo () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
      <div className="row">
        <div className="col-md-12">
          <div className="text-right">
            <button data-toggle="modal" data-target="#modalConfirmacaoNovoMapa" className="btn btn-laranja" onClick={() => this.props.acaoNovoMapa()}>
              Novo Mapa
            </button>
          </div>
        </div>
      </div>
      </Autorizacao>)
  }

  render () {
    return (
        <div>
          <div className="row internas">
            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
              {this.exibirCampoBusca()}
              {this.exibirBotaoNovo()}
              <div className="lista-table mt-4">
                {this.exibirMapas()}
              </div>
            </div>
          </div>
        </div>
    )
  }
}


export const mapStateToProps = state => (
  {
    mapasVeiculos: state.mapasVeiculos.mapasVeiculos,
    paginaAtual: state.paginaAtualCidade,
    registrosPorPagina: state.registrosPorPaginaCidade,
    cidade: state.cidade,
    filtrosMapaVeiculo: state.filtrosMapaVeiculo
  });


export default connect(mapStateToProps, {
  buscarMapasVeiculos, adicionarFiltroMapaVeiculo, determinarPaginaAtualMapasVeiculos, alterarRegistrosPorPaginaMapasVeiculos, changeFieldValue
})(reduxForm({
  form: 'formularioMapasVeiculos'  
})(MapasVeiculos));
